import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import * as guards from './guards';
import * as auth from './auth'
import * as shared from './shared'
import { NewsComponent } from './news/news.component';
import { supllierDataResolver } from './resolver/supplier.data.resolver';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: auth.LoginComponent, canActivate: [guards.guestGuard] },
  { path: 'demo', component: auth.SilentLoginComponent },
  {
    path: 'user-page',
    component: shared.UserPageComponent,
    canActivate: [guards.authGuard],
    resolve: { supplierData: supllierDataResolver },
    children: [
      { path: '', redirectTo: 'settings', pathMatch: 'full' },
      { path: 'settings', component: shared.UserSettingsComponent, canActivate: [guards.authGuard] },
      { path: 'accounts', component: shared.AccountsManagementComponent, canActivate: [guards.authGuard] },

    ]
  },
  { path: 'registration', component: auth.RegistrationSimpleComponent },
  { path: 'registration-full', component: auth.RegistrationComponent },
  { path: 'forgotpassword', component: auth.ForgotPasswordComponent },
  { path: 'resetpassword', component: auth.ResetPasswordComponent },
  { path: 'setuppassword', component: auth.SetupPasswordComponent },
  { path: 'confirmaccount', component: auth.ConfirmAccountComponent },
  // { path: 'settings', component: shared.UserSettingsComponent, canActivate: [guards.authGuard] },
  // { path: 'accounts', component: shared.AccountsManagementComponent, canActivate: [guards.authGuard] },
  { path: 'news/:newsId', component: NewsComponent, canActivate: [guards.authGuard] },
  { path: 'tubesheets', component: shared.TubesheetsInfoComponent, canActivate: [guards.authGuard] },
  {
    path: 'useradmin',
    loadChildren: () => import('./useradmin/useradmin.module').then((m) => m.UserAdminModule),
    canActivate: [guards.authGuard]
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
    canActivate: [guards.authGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [guards.authGuard]
  },
  {
    path: 'orders',
    component: shared.OrdersComponent,
    canActivate: [guards.authGuard]
  },
  {
    path: 'cart-page',
    component: shared.CartPageComponent,
    canActivate: [guards.authGuard]
  },
  {
    path: 'checkout-page',
    component: shared.CheckoutPageComponent,
    canActivate: [guards.authGuard]
  },
  {
    path: 'supplier',
    loadChildren: () => import('./supplier/supplier.module').then((m) => m.SupplierModule),
    canActivate: [guards.authGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
